var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$root.showCaptcha)?_c('v-overlay',{attrs:{"z-index":"200","light":true,"opacity":0.8}},[_c('vue-recaptcha',{ref:"recaptcha",staticStyle:{"z-index":"200 !important"},attrs:{"sitekey":_vm.sitekey},on:{"verify":_vm.onCaptchaVerified}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }